
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as index_7lPTdZqtV92SNXuHQhd1DgWPnj_S7b0wXByqP6luh4Meta } from "/codebuild/output/src2297554842/src/and-dine-hub/pages/index.vue?macro=true";
import { default as loginF05hKWnwmPylBFBC7WadspegbW_451gqsp2O_45YlVxioXIMeta } from "/codebuild/output/src2297554842/src/and-dine-hub/pages/login.vue?macro=true";
import { default as createG0L7MYuc71uobvDR5gSTDkrozJ28av1LYSVVViP_VCsMeta } from "/codebuild/output/src2297554842/src/and-dine-hub/pages/create.vue?macro=true";
import { default as forgotDJ4a6XOp0Pz_457_jSEKinZmm8l_fwmCzsp4032bCMshcMeta } from "/codebuild/output/src2297554842/src/and-dine-hub/pages/forgot.vue?macro=true";
import { default as reportskPC8ZLiBbOOdZromCyzMw_45vg7QgWEvRT6TER7iN3BNkMeta } from "/codebuild/output/src2297554842/src/and-dine-hub/pages/reports.vue?macro=true";
import { default as sign_45upFB9fkEW4SuJwyujkn2dBzISra6ynu1E7nsQ8URGZUegMeta } from "/codebuild/output/src2297554842/src/and-dine-hub/pages/sign-up.vue?macro=true";
import { default as insightsZ2uqHvO89CMXaiVrn4rUDmF44yiCusiq1cAFMLYSIHEMeta } from "/codebuild/output/src2297554842/src/and-dine-hub/pages/insights.vue?macro=true";
import { default as newVh_cVfg50gi5z_UogyLWmXbdJw8AAk1DxvSBjF5YW9QMeta } from "/codebuild/output/src2297554842/src/and-dine-hub/pages/users/new.vue?macro=true";
import { default as newZiVJS6hZMVXgbcrxwdJA1bWSi7VFHkHp8vG_sqcY_fIMeta } from "/codebuild/output/src2297554842/src/and-dine-hub/pages/makers/new.vue?macro=true";
import { default as newNwniQl3MFhsMyxVqi5L3jpegPOHJouLoQtGDkH30YqkMeta } from "/codebuild/output/src2297554842/src/and-dine-hub/pages/orders/new.vue?macro=true";
import { default as _91id_93adwRbin86XXdSiP6O1t1aXep9yt6VRZffOkhYRLymsMMeta } from "/codebuild/output/src2297554842/src/and-dine-hub/pages/users/[id].vue?macro=true";
import { default as newU4sP_45QLfKvNJ1tFtQbaSS9AEMTXQi5TUzEXa3LNvS5EMeta } from "/codebuild/output/src2297554842/src/and-dine-hub/pages/verify/new.vue?macro=true";
import { default as _91id_93ytZqBh0rj5GHJCZ_U7qgmX9N6ERIiKL648suvHNleZ8Meta } from "/codebuild/output/src2297554842/src/and-dine-hub/pages/makers/[id].vue?macro=true";
import { default as newC1ptQtGEhEmbibwZdAcfDiKcGxK2b_a_458gmTlC8kYg8Meta } from "/codebuild/output/src2297554842/src/and-dine-hub/pages/rewards/new.vue?macro=true";
import { default as indexTwkNkEVyPVk51aCg6QD4o5TgXLR7G4YVDPW3hohkPhcMeta } from "/codebuild/output/src2297554842/src/and-dine-hub/pages/users/index.vue?macro=true";
import { default as _91id_93_45UCRrq4basKYqTiEiFXuuGVpiAbuVd5uZNJQuiojVCAMeta } from "/codebuild/output/src2297554842/src/and-dine-hub/pages/verify/[id].vue?macro=true";
import { default as integrationsxoEEwsznGLdshWU0gwHoRUZEdwD6tAGRm1VV6AmkHtgMeta } from "/codebuild/output/src2297554842/src/and-dine-hub/pages/integrations.vue?macro=true";
import { default as index2CLgPGtWD84L0FHx8Run4SBTKzKZxlas0YrRZ5aJ5G0Meta } from "/codebuild/output/src2297554842/src/and-dine-hub/pages/makers/index.vue?macro=true";
import { default as indexHkodzzDnkxEh_45rG3WzG7RCtdlvU0kjrlBgJixuJgHMMMeta } from "/codebuild/output/src2297554842/src/and-dine-hub/pages/orders/index.vue?macro=true";
import { default as newErkr6kibKDAbD_xZHql4QxgCZdH_OecfGBrZR4_mGmQMeta } from "/codebuild/output/src2297554842/src/and-dine-hub/pages/packages/new.vue?macro=true";
import { default as newb3QHDF4tlIigXJBawqb4Qra3puM2LR8iVOAgVH9t9voMeta } from "/codebuild/output/src2297554842/src/and-dine-hub/pages/products/new.vue?macro=true";
import { default as indexUojKm6dbmKXdIzLi_45sLMXS2FPKTi4b9KLKe_45Q_45suJkEMeta } from "/codebuild/output/src2297554842/src/and-dine-hub/pages/queues/index.vue?macro=true";
import { default as _91id_93PwZ3O4tZ95915gsebl4kewUQ5P4J17XZvmOLHXBCaPQMeta } from "/codebuild/output/src2297554842/src/and-dine-hub/pages/rewards/[id].vue?macro=true";
import { default as newebh1QGEZYRdpGGKA1Dyrg_45U6CQm5HdagpePIBqBBe5UMeta } from "/codebuild/output/src2297554842/src/and-dine-hub/pages/settings/new.vue?macro=true";
import { default as newEGXLsEEh2tHv3FaKXNilJiuWdUZ_456VV_ULcC2HfSiMwMeta } from "/codebuild/output/src2297554842/src/and-dine-hub/pages/discounts/new.vue?macro=true";
import { default as _91id_93IeDe8kwQ_45agZyd2b96cFNjPiar2Vjxxi6bugZgCexTsMeta } from "/codebuild/output/src2297554842/src/and-dine-hub/pages/packages/[id].vue?macro=true";
import { default as _91id_93fdU0jZrMv_45DQACakSli4fxEb9Nsi5nIOk4uIC9lJ6PkMeta } from "/codebuild/output/src2297554842/src/and-dine-hub/pages/password/[id].vue?macro=true";
import { default as _91id_93OxS3_N64V9nNh1A7X_45ydJJRCaQLBFwW51VZSh9D3rHQMeta } from "/codebuild/output/src2297554842/src/and-dine-hub/pages/products/[id].vue?macro=true";
import { default as indexUQzIje5qxPYSEezPHNw6YDR1eJKlceVZO6bCibOMIW8Meta } from "/codebuild/output/src2297554842/src/and-dine-hub/pages/rewards/index.vue?macro=true";
import { default as _91id_939rKMQViTWSefWTqGWTuUh1s4fbE0EZ1nPNkgOam9XxAMeta } from "/codebuild/output/src2297554842/src/and-dine-hub/pages/settings/[id].vue?macro=true";
import { default as _91id_93Fft7SchjkpBhFw2vYR0rSy_45jA0C7D9_yBhpCUk6Q0sEMeta } from "/codebuild/output/src2297554842/src/and-dine-hub/pages/customers/[id].vue?macro=true";
import { default as _91id_93mWPQbvLGb_45l9_gedXseQEaODqDaP512RB7VMABJ6Y_QMeta } from "/codebuild/output/src2297554842/src/and-dine-hub/pages/discounts/[id].vue?macro=true";
import { default as downloadxCHE3WaxRuCfHEDzwd6FdD46zqobHxHFxQz1TO28fdQMeta } from "/codebuild/output/src2297554842/src/and-dine-hub/pages/files/download.vue?macro=true";
import { default as indexEeonmfndSeewmdu0mUPAFVgbnr_gPWdw6bZ50HFCBjoMeta } from "/codebuild/output/src2297554842/src/and-dine-hub/pages/packages/index.vue?macro=true";
import { default as index2CsWlbe6_NttlJjpDKj5YiHv_3M4YIwI2aYGv5xJTkAMeta } from "/codebuild/output/src2297554842/src/and-dine-hub/pages/products/index.vue?macro=true";
import { default as indexi_SOb5bj3kMTguFVbhwh4J11dBDYgcN5j_45c7yP5MxBAMeta } from "/codebuild/output/src2297554842/src/and-dine-hub/pages/settings/index.vue?macro=true";
import { default as newuhBVRKAa3EzKzPPbOYJZFYOYp5_fFFPQ8D5FK_erFr0Meta } from "/codebuild/output/src2297554842/src/and-dine-hub/pages/cost-centre/new.vue?macro=true";
import { default as indexRzxwo88cQnQjWLtszXD7LPjxPRiiU_YDZwvULqNECWoMeta } from "/codebuild/output/src2297554842/src/and-dine-hub/pages/customers/index.vue?macro=true";
import { default as indexe0UnAHFqHKdM35vw1EN9fhKOKL7NKhRCeU_yOiSsT9YMeta } from "/codebuild/output/src2297554842/src/and-dine-hub/pages/discounts/index.vue?macro=true";
import { default as _91id_93mTi31jKXoD0zofSoqybInPUjA_45tw3MV3kYC3_45s9ALXIMeta } from "/codebuild/output/src2297554842/src/and-dine-hub/pages/cost-centre/[id].vue?macro=true";
import { default as indexkuAsxi3rNBacBX7fuXcazA3SFRVJapGOEFENUxIPoxIMeta } from "/codebuild/output/src2297554842/src/and-dine-hub/pages/cost-centre/index.vue?macro=true";
import { default as indexTCjgadzZP1y0XZa5iMbjvHvVZp0JFpkwDJhVYy2g7WAMeta } from "/codebuild/output/src2297554842/src/and-dine-hub/pages/orders/[id]/index.vue?macro=true";
import { default as newNg79nrG_45iZUrYS_45P_CfpS5f2UFjzJkwZ7p5oDL_cl0sMeta } from "/codebuild/output/src2297554842/src/and-dine-hub/pages/organisations/new.vue?macro=true";
import { default as _91id_93j5k_TLHo2U4R9P5KJInhXRXvJ_thyAfbkr3PpROEDI0Meta } from "/codebuild/output/src2297554842/src/and-dine-hub/pages/organisations/[id].vue?macro=true";
import { default as indexaD6PI2PuIwjbDaUeq2GHioPU36cpx9HaRqbF_45iUTd00Meta } from "/codebuild/output/src2297554842/src/and-dine-hub/pages/organisations/index.vue?macro=true";
import { default as new5W9oPpXisb2dU3SZx82PjyIu2_45D0QZSvYYvp7v3c48gMeta } from "/codebuild/output/src2297554842/src/and-dine-hub/pages/maker-categories/new.vue?macro=true";
import { default as _91id_93FDwGejDF7Z9yjePXjvwDQSGhYB_45crYIRHaWT6b5sgTkMeta } from "/codebuild/output/src2297554842/src/and-dine-hub/pages/maker-categories/[id].vue?macro=true";
import { default as indexL6Lyy_45e1AP9xV5kPy_TYsQVMSov_457JE7F30VvvoUFscMeta } from "/codebuild/output/src2297554842/src/and-dine-hub/pages/maker-categories/index.vue?macro=true";
import { default as newlXnmgZXXxquU0OjxioX58iIFv60t7_r0jCwBNpiL2SoMeta } from "/codebuild/output/src2297554842/src/and-dine-hub/pages/product-categories/new.vue?macro=true";
import { default as _91id_93C8ABUCRUOH83XfRgwhM_455Pz2vM3XPxGYXIlP_kMvySEMeta } from "/codebuild/output/src2297554842/src/and-dine-hub/pages/product-categories/[id].vue?macro=true";
import { default as indexc_VRW8c4QG8GjB7zAAqU2T_yunksEo_K_aH_45JEbnVqQMeta } from "/codebuild/output/src2297554842/src/and-dine-hub/pages/product-categories/index.vue?macro=true";
import { default as _91id_93512zlS7_458GbriA2ak8tEbPZXQ26k3cO9GIbp0mEXNdYMeta } from "/codebuild/output/src2297554842/src/and-dine-hub/pages/settings/subConfigs/[id].vue?macro=true";
import { default as transaction_45historydIrXRNdia855qpVk2DffY7jSb2fj8TKbEtptbaeacUYMeta } from "/codebuild/output/src2297554842/src/and-dine-hub/pages/orders/[id]/transaction-history.vue?macro=true";
export default [
  {
    name: "index",
    path: "/",
    component: () => import("/codebuild/output/src2297554842/src/and-dine-hub/pages/index.vue")
  },
  {
    name: "login",
    path: "/login",
    component: () => import("/codebuild/output/src2297554842/src/and-dine-hub/pages/login.vue")
  },
  {
    name: "create",
    path: "/create",
    component: () => import("/codebuild/output/src2297554842/src/and-dine-hub/pages/create.vue")
  },
  {
    name: "forgot",
    path: "/forgot",
    component: () => import("/codebuild/output/src2297554842/src/and-dine-hub/pages/forgot.vue")
  },
  {
    name: "reports",
    path: "/reports",
    component: () => import("/codebuild/output/src2297554842/src/and-dine-hub/pages/reports.vue")
  },
  {
    name: "sign-up",
    path: "/sign-up",
    component: () => import("/codebuild/output/src2297554842/src/and-dine-hub/pages/sign-up.vue")
  },
  {
    name: "insights",
    path: "/insights",
    component: () => import("/codebuild/output/src2297554842/src/and-dine-hub/pages/insights.vue")
  },
  {
    name: "users-new",
    path: "/users/new",
    component: () => import("/codebuild/output/src2297554842/src/and-dine-hub/pages/users/new.vue")
  },
  {
    name: "makers-new",
    path: "/makers/new",
    component: () => import("/codebuild/output/src2297554842/src/and-dine-hub/pages/makers/new.vue")
  },
  {
    name: "orders-new",
    path: "/orders/new",
    component: () => import("/codebuild/output/src2297554842/src/and-dine-hub/pages/orders/new.vue")
  },
  {
    name: "users-id",
    path: "/users/:id()",
    component: () => import("/codebuild/output/src2297554842/src/and-dine-hub/pages/users/[id].vue")
  },
  {
    name: "verify-new",
    path: "/verify/new",
    component: () => import("/codebuild/output/src2297554842/src/and-dine-hub/pages/verify/new.vue")
  },
  {
    name: "makers-id",
    path: "/makers/:id()",
    component: () => import("/codebuild/output/src2297554842/src/and-dine-hub/pages/makers/[id].vue")
  },
  {
    name: "rewards-new",
    path: "/rewards/new",
    component: () => import("/codebuild/output/src2297554842/src/and-dine-hub/pages/rewards/new.vue")
  },
  {
    name: "users",
    path: "/users",
    component: () => import("/codebuild/output/src2297554842/src/and-dine-hub/pages/users/index.vue")
  },
  {
    name: "verify-id",
    path: "/verify/:id()",
    component: () => import("/codebuild/output/src2297554842/src/and-dine-hub/pages/verify/[id].vue")
  },
  {
    name: "integrations",
    path: "/integrations",
    component: () => import("/codebuild/output/src2297554842/src/and-dine-hub/pages/integrations.vue")
  },
  {
    name: "makers",
    path: "/makers",
    component: () => import("/codebuild/output/src2297554842/src/and-dine-hub/pages/makers/index.vue")
  },
  {
    name: "orders",
    path: "/orders",
    component: () => import("/codebuild/output/src2297554842/src/and-dine-hub/pages/orders/index.vue")
  },
  {
    name: "packages-new",
    path: "/packages/new",
    component: () => import("/codebuild/output/src2297554842/src/and-dine-hub/pages/packages/new.vue")
  },
  {
    name: "products-new",
    path: "/products/new",
    component: () => import("/codebuild/output/src2297554842/src/and-dine-hub/pages/products/new.vue")
  },
  {
    name: "queues",
    path: "/queues",
    component: () => import("/codebuild/output/src2297554842/src/and-dine-hub/pages/queues/index.vue")
  },
  {
    name: "rewards-id",
    path: "/rewards/:id()",
    component: () => import("/codebuild/output/src2297554842/src/and-dine-hub/pages/rewards/[id].vue")
  },
  {
    name: "settings-new",
    path: "/settings/new",
    component: () => import("/codebuild/output/src2297554842/src/and-dine-hub/pages/settings/new.vue")
  },
  {
    name: "discounts-new",
    path: "/discounts/new",
    component: () => import("/codebuild/output/src2297554842/src/and-dine-hub/pages/discounts/new.vue")
  },
  {
    name: "packages-id",
    path: "/packages/:id()",
    component: () => import("/codebuild/output/src2297554842/src/and-dine-hub/pages/packages/[id].vue")
  },
  {
    name: "password-id",
    path: "/password/:id()",
    component: () => import("/codebuild/output/src2297554842/src/and-dine-hub/pages/password/[id].vue")
  },
  {
    name: "products-id",
    path: "/products/:id()",
    component: () => import("/codebuild/output/src2297554842/src/and-dine-hub/pages/products/[id].vue")
  },
  {
    name: "rewards",
    path: "/rewards",
    component: () => import("/codebuild/output/src2297554842/src/and-dine-hub/pages/rewards/index.vue")
  },
  {
    name: "settings-id",
    path: "/settings/:id()",
    component: () => import("/codebuild/output/src2297554842/src/and-dine-hub/pages/settings/[id].vue")
  },
  {
    name: "customers-id",
    path: "/customers/:id()",
    component: () => import("/codebuild/output/src2297554842/src/and-dine-hub/pages/customers/[id].vue")
  },
  {
    name: "discounts-id",
    path: "/discounts/:id()",
    component: () => import("/codebuild/output/src2297554842/src/and-dine-hub/pages/discounts/[id].vue")
  },
  {
    name: "files-download",
    path: "/files/download",
    component: () => import("/codebuild/output/src2297554842/src/and-dine-hub/pages/files/download.vue")
  },
  {
    name: "packages",
    path: "/packages",
    component: () => import("/codebuild/output/src2297554842/src/and-dine-hub/pages/packages/index.vue")
  },
  {
    name: "products",
    path: "/products",
    component: () => import("/codebuild/output/src2297554842/src/and-dine-hub/pages/products/index.vue")
  },
  {
    name: "settings",
    path: "/settings",
    component: () => import("/codebuild/output/src2297554842/src/and-dine-hub/pages/settings/index.vue")
  },
  {
    name: "cost-centre-new",
    path: "/cost-centre/new",
    component: () => import("/codebuild/output/src2297554842/src/and-dine-hub/pages/cost-centre/new.vue")
  },
  {
    name: "customers",
    path: "/customers",
    component: () => import("/codebuild/output/src2297554842/src/and-dine-hub/pages/customers/index.vue")
  },
  {
    name: "discounts",
    path: "/discounts",
    component: () => import("/codebuild/output/src2297554842/src/and-dine-hub/pages/discounts/index.vue")
  },
  {
    name: "cost-centre-id",
    path: "/cost-centre/:id()",
    component: () => import("/codebuild/output/src2297554842/src/and-dine-hub/pages/cost-centre/[id].vue")
  },
  {
    name: "cost-centre",
    path: "/cost-centre",
    component: () => import("/codebuild/output/src2297554842/src/and-dine-hub/pages/cost-centre/index.vue")
  },
  {
    name: "orders-id",
    path: "/orders/:id()",
    component: () => import("/codebuild/output/src2297554842/src/and-dine-hub/pages/orders/[id]/index.vue")
  },
  {
    name: "organisations-new",
    path: "/organisations/new",
    component: () => import("/codebuild/output/src2297554842/src/and-dine-hub/pages/organisations/new.vue")
  },
  {
    name: "organisations-id",
    path: "/organisations/:id()",
    component: () => import("/codebuild/output/src2297554842/src/and-dine-hub/pages/organisations/[id].vue")
  },
  {
    name: "organisations",
    path: "/organisations",
    component: () => import("/codebuild/output/src2297554842/src/and-dine-hub/pages/organisations/index.vue")
  },
  {
    name: "maker-categories-new",
    path: "/maker-categories/new",
    component: () => import("/codebuild/output/src2297554842/src/and-dine-hub/pages/maker-categories/new.vue")
  },
  {
    name: "maker-categories-id",
    path: "/maker-categories/:id()",
    component: () => import("/codebuild/output/src2297554842/src/and-dine-hub/pages/maker-categories/[id].vue")
  },
  {
    name: "maker-categories",
    path: "/maker-categories",
    component: () => import("/codebuild/output/src2297554842/src/and-dine-hub/pages/maker-categories/index.vue")
  },
  {
    name: "product-categories-new",
    path: "/product-categories/new",
    component: () => import("/codebuild/output/src2297554842/src/and-dine-hub/pages/product-categories/new.vue")
  },
  {
    name: "product-categories-id",
    path: "/product-categories/:id()",
    component: () => import("/codebuild/output/src2297554842/src/and-dine-hub/pages/product-categories/[id].vue")
  },
  {
    name: "product-categories",
    path: "/product-categories",
    component: () => import("/codebuild/output/src2297554842/src/and-dine-hub/pages/product-categories/index.vue")
  },
  {
    name: "settings-subConfigs-id",
    path: "/settings/subConfigs/:id()",
    component: () => import("/codebuild/output/src2297554842/src/and-dine-hub/pages/settings/subConfigs/[id].vue")
  },
  {
    name: "orders-id-transaction-history",
    path: "/orders/:id()/transaction-history",
    component: () => import("/codebuild/output/src2297554842/src/and-dine-hub/pages/orders/[id]/transaction-history.vue")
  }
]